<template>
    <div class="WrongTopicMessage">
        <TopBar/>
        <div class="content">
            <img src="../../assets/img/wrong_message.png" alt="错题不见了">
            <p>同学，暂无错题信息</p>
        </div>
    </div>
</template>

<script>
    import TopBar from "../../components/common/TopBar"

    export default {
        name: "WrongTopicMessage",
        data() {
            return {}
        },
        components: {
            TopBar
        },
    }
</script>

<style lang="scss" scoped>
    .WrongTopicMessage {
        width: 100%;
        height: 100%;
        position: relative;
        .content {
            position: absolute;
            top: 30%;
            left: 50%;
            transform: translate(-50%);
            img {
                width: 215px;
                font-size: 0;
                display: block;
            }
            p {
                text-align: center;
                font-size: 16px;
                padding-top: 24px;
                color: #999999;
            }
        }
    }
</style>
